
import React, { CSSProperties,
                useEffect,
                useRef,
                useState,
                useCallback} from "react";
import {
    Box,
    Typography,
    Toolbar,
    InputAdornment,
    IconButton,
    TextField,
    Card,
    CardContent,
    Tabs,
    Tab,
    Divider,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Grid,
    Avatar,
    Button,
    Popover,
    LinearProgress
} from "@mui/material";
import {ContainerClasses} from '../../themes/containerClasses'
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import MenuIcon from "@mui/icons-material/Menu";
import AccountCircle from "@mui/icons-material/AccountCircle";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import TrendingDownIcon from '@mui/icons-material/TrendingDown';
import TrendingFlatIcon from '@mui/icons-material/TrendingFlat';
import AddIcon from '@mui/icons-material/Add';
import CheckIcon from "@mui/icons-material/Check";
import ScheduleIcon from "@mui/icons-material/Schedule";
import RemoveIcon from '@mui/icons-material/Remove';
import ShoppingCartCheckoutIcon from '@mui/icons-material/ShoppingCartCheckout';
import {useTheme, alpha} from '@mui/material/styles';
import {SparkLineChart} from "@mui/x-charts/SparkLineChart";
import {LayoutFieldModel,
        IconType,
        IconJSON} from '../../models/models';
import {CartAModel,
        CartAJSON,
        CartAFactory,
        EventProductModel,
        ProductModel} from '../../models/modelsCart';
import {formatPrice} from '../../utils/priceFunctions';
import {checkLayoutFieldRequirement} from '../../utils/fieldValidations';
import {KPICardFigure,
        KPICardText,
        KPICardIcon,
        KPICardTrend,
        KPICardSparkline} from '../../models/modelsDashboard';
import {CustomIconComponent} from '../icons/CustomIcon';
import { useAuth } from "../../hooks/useAuth";
import { retrieveCart,
         refreshCart,
         submitCart } from "../../services/cartApi";
import {useSnackbar} from "notistack";
import {getAppName,
        getObjectName} from "../../utils/helperRouter";
import { useNavigate } from "react-router";
import {useParams} from "react-router-dom";
import { DateField } from "@mui/x-date-pickers/DateField";
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';
import dayjs from 'dayjs';
import { CelebrationType,
         CelebrationModel } from '../../models/modelsCelebration';


export interface CelebrationProps {
  trigger: number;
  celebration: CelebrationModel | null;
}


/**********************************/

const random = (min: number, max: number) => {
  return min + Math.random() * (max-min);
}

const randomInt = (min:number, max: number) => {
  return Math.floor(random(min, max+1))
}

const randomItem = <T,>(items: T[]) : T => {
  return items[Math.floor(Math.random() * items.length)];
}

/**********************************/
/**********************************/
/**********************************/

const ROCKET_MS = 700;
const ROCKET_DENSITY = 3;

interface FireworkRocket {
  id: number,
  x: number,
  targetY: number
}

interface FireworkParticle {
  id: string;
  x: number;
  y: number;
  angle: number;
  distance: number;
  size: number;
  duration: number;
  fall: number;
  color: string;
}


const FIREWORK_COLOURS=[
  "#ff5252",
  "#ff4081",
  "#e040fb",
  "#7c4dff",
  "#536dfe",
  "#40c4ff",
  "#18ffff",
  "#64ffda",
  "#69f0ae",
  "#eeff41",
  "#ffd740",
  "#ff6e40"
]

const createFireworkParticles = (
  x: number,
  y: number,
  count: number,
  idStart: number
): FireworkParticle[] => {
  return Array.from({length: count}, (_, index) => {
    const palette = [randomItem(FIREWORK_COLOURS), randomItem(FIREWORK_COLOURS)];
    const offset = Math.random() * Math.PI * 2;
    return {
      id: `firework-${idStart}-${index}`,
      x,
      y,
      angle: offset + (index/count) * Math.PI + random(-0.15,0.15),
      distance: random(70,190),
      size: random(2,5),
      duration: random(800, 1400),
      fall: random(30,90),
      color: Math.random() < 0.15 ? '#ffffff': randomItem(palette)
    }
  })
}

/**********************************/
/**********************************/
/**********************************/

interface Balloon {
  id: string;
  text: string;
  left: number;
  size: number;
  duration: number;
  delay: number;
  drift: number;
  rotation: number;
  color: string;
}

const BALLOON_DENSITY = 0.75;

const BALLOON_COLORS = [
  '#f44336',
  '#e91e63',
  '#9c27b0',
  '#673ab7',
  '#3f51b5',
  '#2196f3',
  '#03a9f4',
  '#00bcd4',
  '#009688',
  '#4caf50',
  '#8bc34a',
  '#ffeb3b',
  '#ffc107',
  '#ff9800',
  '#ff5722'
]

const createBalloons = (
  count: number,
  idStart: number,
  messages: string[]
): Balloon[] => {
  return Array.from({length: count}, (_, index) => {
    const text = messages.length > 0 ? randomItem(messages) : 'Wohoo!';
    return {
      id: `balloon-${idStart}-${index}`,
      text: text,
      left: random(2,98),
//      size: random(30,55),
      size: random(110,160),
      duration: random(4500, 7500),
      delay: random(0, 1200),
      drift: random(-80,80),
      rotation: random(-15,15),
      color: randomItem(BALLOON_COLORS)
    }
  })
}

/**********************************/
/**********************************/
/**********************************/
type ConfettiShape = 'rect' | 'square' | 'circle' | 'strip';

interface ConfettiParticle {
  id: string;
  left: number;
  width: number;
  height: number;
  shape: ConfettiShape;
  duration: number;
  delay: number;
  drift: number;
  wobble: number;
  rotation: number;
  flip: number;
  color: string;
}

const CONFETTI_DENSITY = 10;

const CONFETTI_COLORS = [
  '#f44336',
  '#e91e63',
  '#9c27b0',
  '#3f51b5',
  '#2196f3',
  '#00bcd4',
  '#4caf50',
  '#ffeb3b',
  '#ff9800',
  '#ff5722'
]

const createConfetti = (
  count: number,
  idStart: number
): ConfettiParticle[] => {
  return Array.from({length: count}, (_, index) => {

    const shape = randomItem<ConfettiShape>(['rect', 'square', 'circle', 'strip']);
    const base = random(6,11);

    let width=base;
    let height = base * random(1.4,2);
    if(shape == 'square') height = base;
    if(shape == 'circle') height = base;
    if(shape == 'strip') {
      width=base*0.45;
      height=base*random(2.2,3.2);
    }
    //bigger confetti lower duration (faster)
    const duration = random(3000,5200) + (11-base)*120;
    //small delay at the beginning -> burst creation of confetti
    const delay = Math.random() <0.6 ? random(0,500): random(500, 1800)
    return {
      id: `confetti-${idStart}-${index}`,
      left: random(0, 100),
      width: width,
      height: height,
      shape: shape,
      duration: duration,
      delay: delay,
      drift: random(-140,140),
      wobble: random(15,45),
      rotation: random(-720,720),
      flip: random(720,1800),
      color: randomItem(CONFETTI_COLORS)
    }
  })
}

/**********************************/
/**********************************/
/**********************************/

interface MoneyParticle {
  id: string;
  left: number;
  size: number;
  duration: number;
  delay: number;
  drift: number;
  wobble: number;
  rotation: number;
  opacity: number;
  image: string;
}

const MONEY_DENSITY = 3;

const MONEY = [
  "💶",
  "💵",
  "💷",
  "💴",
  "🪙",
  "💰"
]

const createMoney = (
  count: number,
  idStart: number
): MoneyParticle[] => {
  return Array.from({length: count}, (_, index) => {
    const size = random(25, 45);
    //small delay at the beginning -> burst creation of money
    const delay = Math.random() <0.6 ? random(0,600): random(600, 2000)
    //duration: the bigger the money, the faster it is (shorter durarion)
    const duration = random(3800, 5200) - (size - 25)*40
    return {
      id: `money-${idStart}-${index}`,
      left: random(0, 100),
      size: size,
      duration: duration,
      delay: delay,
      drift: random(-120,120),
      wobble: random(15, 45),
      rotation: random(-540,540),
      opacity: 0.65 + ((size - 25) / 20) * 0.35,
      image: randomItem(MONEY)
    }
  })
}

/**********************************/
/**********************************/
/**********************************/

interface BubbleParticle {
  id: string;
  left: number;
  size: number;
  duration: number;
  delay: number;
  drift: number;
  wobble: number;
  color: string;
}

const BUBBLE_DENSITY = 2;

const BUBBLE_COLORS = [
  '#f44336',
  '#e91e63',
  '#9c27b0',
  '#3f51b5',
  '#2196f3',
  '#00bcd4',
  '#4caf50',
  '#ffeb3b',
  '#ff9800',
  '#ff5722'
]

const createBubbles = (
  count: number,
  idStart: number
): BubbleParticle[] => {
  return Array.from({length: count}, (_, index) => {
    // 40% small, 35% medium, 25% big
    const roll = Math.random();
    const size =
      roll < 0.4 ? random(6, 16) :
      roll < 0.75 ? random(20, 60) :
      random(70, 150);
    //duration: small bubbles are faster
    const duration = random(3500,6000) + size * 8;
    return {
      id: `bubble-${idStart}-${index}`,
      left: random(0, 100),
      size: size,
      duration: duration,
      delay: random(0, 1800),
      drift: random(-150,150),
      wobble: random(10,35) + size * 0.15,
      color: randomItem(BUBBLE_COLORS)
    }
  }
 )
}


/******************************************/
/******************************************/
/******************************************/

const NO_TYPES: CelebrationType[] = [];
const NO_MESSAGES: string[] = [];

export const CelebrationComponent = ({
  trigger,
  celebration=null
}: CelebrationProps) => {

  const duration = celebration?.duration ?? 5000;
  const intensity = celebration?.intensity ?? 30;
  const types = celebration?.types ?? NO_TYPES;
  const messages = celebration?.messages ?? NO_MESSAGES;

  const previousTrigger = useRef(trigger);
  const idCounter = useRef(0);

  const [fireworks, setFireworks] = useState<FireworkRocket[]>([]);
  const [fireworkParticles, setFireworkParticles] = useState<FireworkParticle[]>([]);

  const [balloons, setBalloons] = useState<Balloon[]>([]);
  const [confetti, setConfetti] = useState<ConfettiParticle[]>([]);
  const [money, setMoney] = useState<MoneyParticle[]>([]);
  const [bubbles, setBubbles] = useState<BubbleParticle[]>([]);

  const nextId = useCallback((count = 1) => {
    const current = idCounter.current;
    idCounter.current = idCounter.current + count;
    return current;
  }, []);

  const timers = useRef<Set<number>>(new Set());

  const schedule = useCallback((fn: () => void, ms: number) => {
    const id = window.setTimeout(() => {
      timers.current.delete(id);
      fn();
    }, ms);
    timers.current.add(id);
  }, []);

  /******************************/
  /*FIREWORKS                   */
  /******************************/


  const addExplosion = useCallback(
    (x: number, y: number, count: number) => {
      const particles = createFireworkParticles(x, y, count, nextId(count));
      setFireworkParticles((prev) => [...prev, ...particles]);

      // remove only this explosion's particles once they've finished
      const ids = new Set(particles.map((p) => p.id));
      const longest = Math.max(...particles.map((p) => p.duration));
      schedule(() => {
        setFireworkParticles((prev) => prev.filter((p) => !ids.has(p.id)));
      }, longest + 100);
    },
    [nextId, schedule]
  );

  const createExplosion = useCallback(
    (x: number, y: number) => {
      addExplosion(x, y, 60);

      // sometimes a smaller secondary burst (never chains)
      if (Math.random() < 0.35) {
        schedule(() => {
          addExplosion(x + random(-8, 8), y + random(-8, 8), randomInt(20, 35));
        }, random(250, 500));
      }
    },
    [addExplosion, schedule]
  );

  const launchFirework = useCallback(() => {
    const x = random(15, 85);
    const targetY = random(15, 40);
    const rocketId = nextId();

    const thisRocket = {
      id: rocketId,
      x: x,
      targetY: targetY
    }
    setFireworks((prev) => [...prev, thisRocket]);

    schedule(() => {
      setFireworks((prev) => prev.filter((r) => r.id !== rocketId));
      createExplosion(x, targetY);
    }, ROCKET_MS);
  }, [createExplosion, nextId, schedule]);

  const launchFireworks = useCallback(() => {
    const showLength = Math.min(duration, 3500);
    //base number of rockets
    const baseCount = Math.max(3, Math.round(intensity / 10) + Math.floor(showLength / 700));
    const count = Math.round(baseCount * ROCKET_DENSITY);

    // spread the launches evenly over the show, with a little jitter
    for (let i = 0; i < count; i++) {
      schedule(launchFirework, (i / count) * showLength + random(0, 250));
    }
  }, [duration, intensity, launchFirework, schedule]);

  /******************************/
  /*BALLOONS                    */
  /******************************/

  const launchBalloons = useCallback(() => {
    const baseCount = Math.max(10, intensity)
    const count = Math.round(baseCount * BALLOON_DENSITY);
    const items = createBalloons(count, nextId(count), messages);

    setBalloons((prev) => [...prev, ...items]);

    //timeout to maximum lifetime of a balloon
    const ids = new Set(items.map((b) => b.id));
    const longest = Math.max(...items.map(b => b.delay + b.duration));
    schedule(() => {
      setBalloons((prev) => prev.filter((b) => !ids.has(b.id)));
    }, longest + 100)

  }, [intensity, messages, nextId, schedule]);

  /******************************/
  /*CONFETTI                    */
  /******************************/

  const launchConfetti = useCallback(() => {
    const baseCount = Math.max(10, intensity)
    const count = Math.round(baseCount * CONFETTI_DENSITY);
    const items = createConfetti(count, nextId(count));
    setConfetti((prev) => [...prev, ...items]);

    //timeout to maximum lifetime of confetti
    const ids = new Set(items.map((c) => c.id));
    const longest = Math.max(...items.map(c => c.delay + c.duration));
    schedule(() => {
      setConfetti((prev) => prev.filter((c) => !ids.has(c.id)));
    }, longest + 100)

  }, [intensity, nextId, schedule]);

  /******************************/
  /*MONEY                      */
  /******************************/

  const launchMoney = useCallback(() => {
    const baseCount = Math.max(10, intensity)
    const count = Math.round(baseCount * MONEY_DENSITY);
    const items = createMoney(count, nextId(count));
    setMoney((prev) => [...prev, ...items]);

    //timeout to maximum lifetime of money
    const ids = new Set(items.map((c) => c.id));
    const longest = Math.max(...items.map(c => c.delay + c.duration));
    schedule(() => {
      setMoney((prev) => prev.filter((c) => !ids.has(c.id)));
    }, longest + 100)

  }, [intensity, nextId, schedule]);


  /******************************/
  /*BUBBLES                      */
  /******************************/

  const launchBubbles = useCallback(() => {
    const baseCount = Math.max(10, intensity)
    const count = Math.round(baseCount * BUBBLE_DENSITY);
    const items = createBubbles(count, nextId(count));
    setBubbles((prev) => [...prev, ...items]);

    //timeout to maximum lifetime of all bubble
    const ids = new Set(items.map((c) => c.id));
    const longest = Math.max(...items.map(c => c.delay + c.duration));
    schedule(() => {
      setBubbles((prev) => prev.filter((c) => !ids.has(c.id)));
    }, longest + 100)

  }, [intensity, nextId, schedule]);

  /******************************/
  /*Trigger                     */
  /******************************/


  useEffect(() => {
    const active = timers.current;
    return () => {
      active.forEach((t) => window.clearTimeout(t));
      active.clear();
    };
  }, []);


  useEffect(() => {
    if(trigger === previousTrigger.current){
      return;
    }
    if(!celebration) {
      return;
    }

    previousTrigger.current=trigger;

    types.forEach((type) => {
      switch(type) {
        case "fireworks":
          launchFireworks();
          break;
        case "balloons":
          launchBalloons();
          break;
        case "confetti":
          launchConfetti();
          break;
        case "money":
          launchMoney();
          break;
        case "bubbles":
          launchBubbles();
          break;
        }
    })
  }, [
    trigger,
    celebration,
    launchFireworks,
    launchBalloons,
    launchConfetti,
    launchMoney,
    launchBubbles
  ]);


  /******************************/
  /*Render                      */
  /******************************/

  return (
    <>
      <div className="celebration-layer">

        {/*********** ROCKETS ********/}
        {fireworks.map((rocket) => {
          return (
            <span
              key={rocket.id}
              className="celebration-rocket"
              style={
                {
                  left: `${rocket.x}%`,
                  animationDuration: `${ROCKET_MS}ms`,
                  "--target-y": `${rocket.targetY}vh`
                } as CSSProperties
              }
            />
          )
        })}


        {/*********** FIREWORK PARTICLES ********/}
        {fireworkParticles.map((particle) => {
          const dx = Math.cos(particle.angle)*particle.distance;
          const dy = Math.sin(particle.angle)*particle.distance;
          return (
            <span
              key={particle.id}
              className="celebration-firework-particle"
              style={
                {
                  left: `${particle.x}%`,
                  top: `${particle.y}vh`,
                  width: `${particle.size}px`,
                  height: `${particle.size}px`,
                  marginLeft: `${-particle.size / 2}px`,
                  marginTop: `${-particle.size / 2}px`,
                  animationDuration: `${particle.duration}ms`,
                  "--dx": `${dx}px`,
                  "--dy": `${dy}px`,
                  "--fall": `${particle.fall}px`,
                  "--particle-color": particle.color
                } as CSSProperties
              }
            />
          )
        })}

        {/*********** BALLOONS ********/}
        {balloons.map((balloon) => {
          return (
            <div
              key={balloon.id}
              className="celebration-balloon-wrapper"
              style={
                {
                  left: `${balloon.left}%`,
                  "--balloon-size": `${balloon.size}px`,
                  "--balloon-color": `${balloon.color}`,
                  "--balloon-drift": `${balloon.drift}px`,
                  "--balloon-rotation": `${balloon.rotation}deg`,
                  animationDuration: `${balloon.duration}ms`,
                  animationDelay: `${balloon.delay}ms`,
                } as CSSProperties
              }
            >

              <div className="celebration-balloon">
                <div className="celebration-balloon-shine" />
                <span className="celebration-balloon-text">
                  {balloon.text}
                </span>
                <span className="celebration-balloon-knot"/>

                <svg className="celebration-balloon-string"
                  viewBox="0 0 40 180"
                  preserveAspectRatio="none"
                  aria-hidden="true"
                >
                  <path
                    d="M20 0 C5 45, 35 80, 18 125 C10 145, 28 160, 20 180"
                    fill="none"
                    stroke="rgba(255, 255, 255, 0.55)"
                    strokeWidth="1.5"
                  />
                </svg>
              </div>
            </div>
          )
        })}


        {/*********** CONFETTI PARTICLES ********/}
        {confetti.map((particle) => {
          return (
            <span
              key={particle.id}
              className={`celebration-confetti celebration-confetti-${particle.shape}`}
              style={
                {
                  left: `${particle.left}%`,
                  width: `${particle.width}px`,
                  height: `${particle.height}px`,
                  background: particle.color,
                  animationDuration: `${particle.duration}ms`,
                  animationDelay: `${particle.delay}ms`,
                  "--confetti-drift": `${particle.drift}px`,
                  "--confetti-rotation": `${particle.rotation}deg`,
                  "--confetti-wobble": `${particle.wobble}px`,
                  "--confetti-flip": `${particle.flip}deg`,
                } as CSSProperties
              }
            />
          )
        })}


        {/*********** MONEY PARTICLES ********/}
        {money.map((particle) => {
          return (
            <span
              key={particle.id}
              className="celebration-money"
              style={
                {
                  left: `${particle.left}%`,
                  fontSize: `${particle.size}px`,
                  animationDuration: `${particle.duration}ms`,
                  animationDelay: `${particle.delay}ms`,
                  "--money-drift": `${particle.drift}px`,
                  "--money-wobble": `${particle.wobble}px`,
                  "--money-rotation": `${particle.rotation}deg`,
                  "--money-opacity": particle.opacity
                } as CSSProperties
              }
            >
              {particle.image}
            </span>
          )
        })}


        {/*********** BUBBLE PARTICLES ********/}
        {bubbles.map((particle) => {
          return (
            <span
              key={particle.id}
              className="celebration-bubble"
              style={
                {
                  left: `${particle.left}%`,
                  width: `${particle.size}px`,
                  height: `${particle.size}px`,
                  animationDuration: `${particle.duration}ms`,
                  animationDelay: `${particle.delay}ms`,
                  "--bubble-size": `${particle.size}px`,
                  "--bubble-color": particle.color,
                  "--bubble-drift": `${particle.drift}px`,
                  "--bubble-wobble": `${particle.wobble}px`
                } as CSSProperties
              }
            >
              <span className="celebration-bubble-highlight"/>
              <span className="celebration-bubble-highlight-small"/>
            </span>
          )
        })}


      </div>

      {/***********INLINE STYLE ********/
       /********************************/
       /********************************/}
      <style>{`
        /***********CONTAINER ********/
        .celebration-layer {
          position: fixed;
          inset: 0;
          overflow: hidden;
          pointer-events: none;
          z-index: 99999;
        }

        /***********FIREWORKS ********/
        .celebration-rocket {
          position: absolute;
          bottom: -30px;
          width: 3px;
          height: 30px;
          margin-left: -1.5px;
          border-radius: 999px;
          background: linear-gradient(to top, rgba(255, 255, 255, 0), #fff);
          box-shadow:
            0 0 6px #fff,
            0 0 12px rgba(255,255,255,0.9);
          will-change: transform;
          animation-name: celebration-rocket-launch;
          animation-timing-function: cubic-bezier(0.25,0.8,0.3,1);
          animation-fill-mode: forwards;
        }

        @keyframes celebration-rocket-launch {
          from {
            transform: translateY(0);
          }
          to {
            transform: translateY(calc(-1 * (100vh - var(--target-y))));
          }
        }

        .celebration-firework-particle {
          position: absolute;
          border-radius: 50%;
          background: var(--particle-color);
          box-shadow:
            0 0 5px var(--particle-color),
            0 0 12px var(--particle-color);
          will-change: transform, opacity;
          animation-name: celebration-explode;
          animation-fill-mode: forwards;
        }

        @keyframes celebration-explode {
          0% {
            transform: translate(0,0) scale(1);
            opacity: 1;
            animation-timing-function: cubic-bezier(0.1, 0.7, 0.3, 1);
          }
          70% {
            transform: translate(var(--dx), var(--dy)) scale(0.8);
            opacity: 1;
            animation-timing-function: ease-in;
          }
          100% {
            transform: translate(var(--dx), calc(var(--dy) + var(--fall))) scale(0);
            opacity: 0;
          }
        }

        /***********BALLOONS ********/
        .celebration-balloon-wrapper {
          position: absolute;
          bottom: calc(-1*(var(--balloon-size) + 200px));
          margin-left: calc(var(--balloon-size) / -2);
          width: var(--balloon-size);
          height: calc(var(--balloon-size) + 190px);
          display: flex;
          transform-origin: 50% 0;
          will-change: transform, opacity;
          justify-content: center;
          animation-name: celebration-balloon-rise;
          animation-timing-function: linear;
          animation-fill-mode: both;
        }

        .celebration-balloon {
          position: relative;
          width: var(--balloon-size);
          height: var(--balloon-size);
          border-radius: 50% 50% 45% 45%;
          background:
            radial-gradient(
              circle at 30% 25%,
              rgba(255,255,255, 0.55) 0%,
              rgba(255,255,255, 0.18) 12%,
              color-mix(in srgb, var(--balloon-color) 90%, transparent) 45%,
              color-mix(in srgb, var(--balloon-color) 65%, transparent) 100%
            );
          border: 1px solid rgba(255, 255, 255, 0.55);
          box-shadow:
            inset 8px 8px 18px rgba(255,255,255,0.3),
            inset -8px -12px 20px rgba(0,0,0,0.08),
            0 8px 20px rgba(0,0,0,0.12);
          backdrop-filter: blur(2px);
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .celebration-balloon-shine {
          position: absolute;
          top: 10%;
          left: 17%;
          width: 27%;
          height: 38%;
          border-radius: 50%;
          background: linear-gradient(
            135deg,
            rgba(255,255,255,0.8),
            rgba(255,255,255,0.05)
          );
          transform: rotate(25deg);
          filter: blur(1px);
          pointer-events: none;
        }

        .celebration-balloon-text {
          position: relative;
          z-index: 2;
          max-width: 80%;
          color: rgba(255, 255, 255, 0.95);
          font-size: clamp(16px, 2vw, 26px);
          font-weight: 700;
          text-align: center;
          line-height: 1.1;
          text-shadow:
            0 1px 2px rgba(0,0,0,0.25),
            0 1px 5px rgba(255,255,255,0.35);
          pointer-events: none;
        }

        .celebration-balloon-knot {
          position: absolute;
          bottom: -7px;
          left: 50%;
          width: 13px;
          height: 13px;
          transform: translateX(-50%) rotate(45deg);
          background: var(--balloon-color);
          opacity: 0.75;
          border-right: 1px solid rgba(255,255,255,0.4);
          border-bottom: 1px solid rgba(255,255,255,0.4);
        }
        .celebration-balloon-string {
          position: absolute;
          top: calc(var(--balloon-size) - 1px);
          left: 50%;
          width: 40px;
          height: 180px;
          transform: translateX(-50%);
          overflow: visible;
          pointer-events: none;
          opacity: 0.75;
        }

        @keyframes celebration-balloon-rise {
          0% {
            transform:
              translate3d(0,0,0)
              rotate(0deg);
              opacity: 0;
          }
          8% {
            opacity: 1;
          }
          25% {
            transform:
              translate3d(calc(var(--balloon-drift)*-0.3),-25vh,0)
              rotate(var(--balloon-rotation));
          }
          50% {
            transform:
              translate3d(var(--balloon-drift),-50vh,0)
              rotate(calc(var(--balloon-rotation)*-1))
              scale(1);
          }
          75% {
            transform:
              translate3d(calc(var(--balloon-drift)*-0.5),-80vh,0)
              rotate(var(--balloon-rotation));
          }
          100% {
            transform:
              translate3d(var(--balloon-drift),-125vh,0)
              rotate(calc(var(--balloon-rotation)*-1));
            opacity: 1;
          }
        }


        /***********CONFETTI ********/
        .celebration-confetti {
          position: absolute;
          top: -30px;
          opacity: 0;
          will-change: transform;
          animation-name: celebration-confetti-fall;
          animation-timing-function: linear;
          animation-fill-mode: both;
          transform-origin: center;
          backface-visibility: visible;
        }

        .celebration-confetti-rect   { border-radius: 1px; }
        .celebration-confetti-square { border-radius: 2px; }
        .celebration-confetti-circle { border-radius: 50%; }
        .celebration-confetti-strip  { border-radius: 2px; }

        @keyframes celebration-confetti-fall {
          0% {
            transform:
              translate3d(0, -20px, 0)
              perspective(600px)
              rotateZ(0deg)
              rotateX(0deg);
            opacity: 0;
          }
          8% {
            opacity: 1;
          }
          25% {
            transform:
              translate3d(calc(var(--confetti-drift)*0.2 + var(--confetti-wobble)), 25vh, 0)
              perspective(600px)
              rotateZ(calc(var(--confetti-rotation)*0.25))
              rotateX(calc(var(--confetti-flip)*0.25));
          }
          50% {
            transform:
              translate3d(calc(var(--confetti-drift)* -0.4 - var(--confetti-wobble)), 52vh, 0)
              perspective(600px)
              rotateZ(calc(var(--confetti-rotation)*0.5))
              rotateX(calc(var(--confetti-flip)*0.55));
          }
          75% {
            transform:
              translate3d(calc(var(--confetti-drift)*0.5 + var(--confetti-wobble)*0.6), 82vh, 0)
              perspective(600px)
              rotateZ(calc(var(--confetti-rotation)*0.8))
              rotateX(calc(var(--confetti-flip)*0.8));
          }
          100% {
            transform:
              translate3d(var(--confetti-drift), 115vh, 0)
              perspective(600px)
              rotateZ(var(--confetti-rotation))
              rotateX(var(--confetti-flip));
            opacity: 1;
          }
        }

        /***********MONEY ********/
        .celebration-money {
          position: absolute;
          top: -80px;
          display: block;
          user-select: none;
          opacity: 0;
          will-change: transform;
          filter: drop-shadow(0 2px 3px rgba(0,0,0,0.25));
          animation-name: celebration-money-fall;
          animation-timing-function: linear;
          animation-fill-mode: forwards;
          transform-origin: center;
        }

        @keyframes celebration-money-fall {
          0% {
            transform:
              translate3d(0, -80px, 0)
              perspective(600px)
              rotateZ(0deg)
              rotateY(0deg)
              rotateX(0deg);
            opacity: 0;
          }
          10% {
            opacity: var(--money-opacity);
          }
          25% {
            transform:
              translate3d(calc(var(--money-drift) * 0.2 + var(--money-wobble)), 25vh, 0)
              perspective(600px)
              rotateZ(calc(var(--money-rotation) * 0.25))
              rotateY(150deg)
              rotateX(20deg);
          }
          50% {
            transform:
              translate3d(calc(var(--money-drift) * -0.3 - var(--money-wobble)), 55vh, 0)
              perspective(600px)
              rotateZ(calc(var(--money-rotation) * 0.5))
              rotateY(330deg)
              rotateX(-20deg);
          }
          75% {
            transform:
              translate3d(calc(var(--money-drift) * 0.4 + var(--money-wobble) * 0.6), 85vh, 0)
              perspective(600px)
              rotateZ(calc(var(--money-rotation) * 0.8))
              rotateY(510deg)
              rotateX(15deg);
          }
          100% {
            transform:
              translate3d(var(--money-drift), 115vh, 0)
              perspective(600px)
              rotateZ(var(--money-rotation))
              rotateY(720deg)
              rotateX(0deg);
            opacity: 0.9;
          }
        }


        /***********BUBBLES ********/
        .celebration-bubble {
          position: absolute;
          bottom: calc(var(--bubble-size) * -1 - 20px);
          border-radius: 50%;
          opacity: 0;
          background:
            radial-gradient(
              circle at 30% 25%,
              rgba(255, 255, 255, 0.7) 0%,
              rgba(255, 255, 255, 0.15) 8%,
              rgba(255, 255, 255, 0.02) 35%,
              color-mix(in srgb, var(--bubble-color) 22%, transparent) 70%,
              color-mix(in srgb, var(--bubble-color) 45%, transparent) 100%
            );
          border: 1.5px solid rgba(255, 255, 255, 0.65);
          box-shadow:
            inset calc(var(--bubble-size)*0.04) calc(var(--bubble-size)*0.04) calc(var(--bubble-size)*0.08) rgba(255,255,255,0.6),
            inset calc(var(--bubble-size)*-0.04) calc(var(--bubble-size)*-0.05) calc(var(--bubble-size)*0.08) color-mix(in srgb, var(--bubble-color) 30%, transparent),
            0 0 8px rgba(255,255,255,0.15);
          animation-name: celebration-bubble-rise;
          animation-timing-function: ease-in-out;
          animation-fill-mode: forwards;
        }

        .celebration-bubble-highlight {
          position: absolute;
          top: 15%;
          left: 18%;
          width: 25%;
          height: 16%;
          border-radius: 50%;
          background: rgba(255,255,255,0.8);
          filter: blur(1px);
          transform: rotate(-30deg);
        }

        .celebration-bubble-highlight-small {
          position: absolute;
          top: 24%;
          left: 27%;
          width: 10%;
          height: 7%;
          border-radius: 50%;
          background: rgba(255,255,255,0.9);
          filter: blur(0.5px);
        }

        @keyframes celebration-bubble-rise {
          0% {
            transform: translate3d(0, 0, 0) scale(0.7);
            opacity: 0;
          }
          8% {
            opacity: 0.9;
          }
          25% {
            transform:
              translate3d(calc(var(--bubble-drift)*0.4 + var(--bubble-wobble)), -25vh, 0)
              scale(0.9);
          }
          45% {
            transform:
              translate3d(calc(var(--bubble-drift)*-0.2 - var(--bubble-wobble)), -45vh, 0)
              scale(1);
          }
          65% {
            transform:
              translate3d(calc(var(--bubble-drift)*-0.5 + var(--bubble-wobble)), -65vh, 0)
              scale(0.95);
          }
          85% {
            transform:
              translate3d(calc(var(--bubble-drift)*-0.3 - var(--bubble-wobble)*0.5), -90vh, 0)
              scale(1.05);
            opacity: 0.9;
          }
          100% {
            transform:
              translate3d(var(--bubble-drift), -125vh, 0)
              scale(1.1);
            opacity: 0;
          }
        }

        /***********REDUCED MOTION ********/

        @media(prefers-reduced-motion: reduce) {
          .celebration-layer{
            display: none;
          }
        }
        `}

      </style>

    </>
  )
}
